/**
 * Copyright 2025 Paion Data. All rights reserved.
 */
import "bootstrap/dist/css/bootstrap.min.css";
import Home from "./components/Home/Home";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import TourRoute from "./components/TourRoute/TourRoute";

import { tourRouts } from "./routs";

export default function App(): JSX.Element {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/shenzhen" element={<TourRoute {...tourRouts.shenzhen} />} />
        <Route path="/chongqing" element={<TourRoute {...tourRouts.chongqing} />} />
        <Route path="/beijing" element={<TourRoute {...tourRouts.beijing} />} />
        <Route path="/guilin" element={<TourRoute {...tourRouts.guilin} />} />
        <Route path="/xian" element={<TourRoute {...tourRouts.xian} />} />
        <Route path="/suzhou" element={<TourRoute {...tourRouts.suzhou} />} />
        <Route path="/xiamen" element={<TourRoute {...tourRouts.xiamen} />} />
        <Route path="/changsha" element={<TourRoute {...tourRouts.changsha} />} />
      </Routes>
    </BrowserRouter>
  );
}
